import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiPlatformProgressIndicatorCircleComponent } from './components/progress-indicator-circle/progress-indicator-circle.component';
import { UiPlatformProgressIndicatorLineComponent } from './components/progress-indicator-line/progress-indicator-line.component';

@NgModule({
  declarations: [
    UiPlatformProgressIndicatorLineComponent,
    UiPlatformProgressIndicatorCircleComponent
  ],
  exports: [
    UiPlatformProgressIndicatorLineComponent,
    UiPlatformProgressIndicatorCircleComponent
  ],
  imports: [CommonModule]
})
export class UiPlatformProgressIndicatorsModule {}
